import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Use localStorage as default
import { persistReducer, persistStore } from "redux-persist";

import authReducer from "./authSlice"; 
import trainingReducer from "./trainingForm"; 
import cartReducer from "./cartForm"; 

const persistConfig = {
  key: "root",
  storage,
};

const persistedTrainingReducer = persistReducer(persistConfig, trainingReducer, cartReducer);

const store = configureStore({
  reducer: {
    auth: authReducer,
    training: persistedTrainingReducer,
    cartForm: cartReducer
  },
});

export const persistor = persistStore(store);
export default store;
